import React from 'react';

// custom components
import { Title } from "_atoms";
import TimelineContainer from "./timeline-container";
import TimelineCard from "./timeline-card";
import ControlPanel from './control-panel';

//bootstrap
import { Col, Row } from 'react-bootstrap';

const ControlPanelComponent = () => {
    return (
        <Row className="p-2">
            <Col>
                <Title subtitle={"Timeline Control Panel"} description={"Control the timeline different features"} />
            </Col>
            <TimelineContainer>
                <TimelineCard>
                    <ControlPanel />
                </TimelineCard>
            </TimelineContainer>
        </Row>
    )
}

export default ControlPanelComponent
